/**
 * Model for the full input of a contact
 */
export class Contact {
    /**
     * Flag if the user wants a newsletter or not
     * @type {boolean}
     */
    public wants_newsletter: boolean = false;

    /**
     * Flag if the user wants postinfos or not
     * @type {boolean}
     */
    public wants_postinfo: boolean = false;

    /**
     * Flag if the user wants a donation_receipt or not
     * @type {boolean}
     */
    public wants_donation_receipt: boolean = false;

    /**
     * TI: share internal
     */
    public share_internal: boolean;

    /**
     * Holds the Contact data of the user
     * @type {ContactData}
     */
    public data: ContactData = new ContactData();
}

/**
 * Model for the contact data of a user
 */
export class ContactData {
    /**
     * E-Mail
     */
    public email: string;

    /**
     * Title
     */
    public title: string;

    /**
     * Country
     */
    public country: string;

    /**
     * Salutation (male, female, divers)
     */
    public salutation: string;

    /**
     * Firstname
     */
    public firstname: string;

    /**
     * Lastname
     */
    public lastname: string;

    /**
     * Postalcode
     */
    public postal_code: string;

    /**
     * City
     */
    public city: string;

    /**
     * Street
     */
    public street: string;

    /**
     * additional address info
     */
    public address_additional_info: string;

    /**
     * Telephone
     */
    public telephone: string;

    /**
     * Name of the company
     */
    public company: string;

    /**
     * Job of the user
     */
    public job: string;

    /**
     * Birtday of the user
     */
    public birthday: string;

    /**
     * Extrafield
     */
    public extra: string;

    /**
     * TI: remarks
     * @deprecated Only for one customer which not longer need this. Use Donation.remarks insted.
     */
    public remarks: string;

    /**
     * TI: interests
     */
    public interests: string;

    /**
     * Some additional data that can be set by  extra config or in custom widgets.
     */
    public additional: any = {};
}
